export default __webpack_public_path__ + "static/media/image.aasa-it-solutions.61c300da.png";